import styled from '@emotion/styled/macro';
import { BaseButton, forPhoneOnly } from '@enter/core';

export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 24px;
    flex-grow: 1;
`;
export const DialogMessage = styled.div`
    ${forPhoneOnly(`
        min-width: auto;
    `)};
`;

export const DialogActions = styled.div`
    display: flex;
    align-self: flex-end;
    padding: 16px 24px;

    ${forPhoneOnly(`
        align-self: stretch;
        flex-direction: column;
        align-items: stretch;
    `)};
`;

export const DialogButton = styled(BaseButton)`
    margin-left: 24px;
    ${forPhoneOnly(`
        margin-left: 0;
        margin-bottom: 16px;
    `)};
`;

export const Countdown = styled.div`
    padding: 24px;
    text-align: center;
    font-size: 24px;
`;
